export const BASE_URL = (window as any)._env_
  ? (window as any)._env_.REACT_APP_API_URL
  : process.env.REACT_APP_API_URL;

export const CONSULT_UPDATE_DEBOUNCE_TIME = 400;
